export default __webpack_public_path__ + "assets/img_webp/integral_2.png";